import { sharedPointSources, sharedPolygonSources, makeDivisionWiseLayerGroup } from './helpers';
import {
    // populationColorMap, populationLegendURL, 
    slantLinePatternColor,
    adolescentBirthColorMap, adolescentBirthLegendURL, adolescentBirthLegendURLNepali,
    // birthDiffColorMap, birthDiffLegendURL,
    adolescentBirthRadiusMap
} from './choroplethLegends';
import { getPointStyle, getPolygonStyle, getCircleStyle } from './styles';
import {findDataForCode} from '../api';


const populationStyles = {
    state: getPolygonStyle('red', 'rbga(255,255,255,0)', 1.5),
    district: getPolygonStyle('yellow', 'rbga(255,255,255,0)', 1),
    municipality: getPolygonStyle('white', 'rbga(255,255,255,0)', 0.2),
};

export const populationLayers = makeDivisionWiseLayerGroup({
    sources: sharedPolygonSources,
    styles: populationStyles,
    zIndex: 1,
    opacity: 0.8,
});

export const updatePopulationStyle = ({stateData, districtData, municipalityData, colorMap}) =>
{
    populationLayers.state.setStyle(feature =>
    {
        const dataItem = findDataForCode(stateData, feature.get('SCode'));
        const color = dataItem ? colorMap(dataItem.value) : slantLinePatternColor;
        populationStyles.state.getFill().setColor(color);
        return populationStyles.state;
    });
    populationLayers.district.setStyle(feature =>
    {
        const dataItem = findDataForCode(districtData, feature.get('DCode'))
        const color = dataItem ? colorMap(dataItem.value) : slantLinePatternColor;
        populationStyles.district.getFill().setColor(color);
        return populationStyles.district;
    });
    populationLayers.municipality.setStyle(feature =>
    {
        const dataItem = findDataForCode(municipalityData, feature.get('SDDMM'))
        const color = dataItem ? colorMap(dataItem.value) : slantLinePatternColor;
        populationStyles.municipality.getFill().setColor(color);
        return populationStyles.municipality;
    });
};

export const setPopulationLayersVisible = (visible) =>
{
    Object.values(populationLayers).forEach(layer => layer.setVisible(visible));
};

const adolescentBirthStyles = {
    state: getPointStyle('rgba(0,0,0,0)', 'black', 1),
    district: getPointStyle('rgba(0,0,0,0)', 'black', 1),
    municipality: getPointStyle('rgba(0,0,0,0)', 'black', 1),
    transparent: getPointStyle('rgba(0,0,0,0)', 'rgba(0,0,0,0)', 0)
};

export const adolescentBirthLayers = makeDivisionWiseLayerGroup({
    sources: sharedPointSources,
    styles: adolescentBirthStyles,
    zIndex: 100,
});

const getDistinctPropertyList = (layer, property) =>
{
    return layer.getSource().getFeatures().map(ftr => ftr.get(property)).filter((val, index, self) => self.indexOf(val)===index);
}

export const updateAdolescentBirthStyle = ({stateData, districtData, municipalityData, colorMap}) =>
{
    adolescentBirthLayers.state.setStyle(feature =>
    {
        const scodesFromDistricts = getDistinctPropertyList(adolescentBirthLayers.district, 'SCode');
        const scodesFromMunicipalities = getDistinctPropertyList(adolescentBirthLayers.municipality, 'SCode');
        const scodesToExclude = [...scodesFromDistricts, ...scodesFromMunicipalities];
        if ( scodesToExclude.indexOf( feature.get('SCode') ) !== -1)
        {
            return adolescentBirthStyles.transparent;
        }
        const dataItem = findDataForCode(stateData, feature.get('SCode'))
        const value = dataItem ? dataItem.value : 0
        const radius = adolescentBirthRadiusMap(value);
        const color = colorMap(value);
        adolescentBirthStyles.state.setImage( getCircleStyle(radius, color) );
        return adolescentBirthStyles.state;
    });
    adolescentBirthLayers.district.setStyle(feature =>
    {
        const scodesFromMunicipalities = getDistinctPropertyList(adolescentBirthLayers.municipality, 'DCode');
        if ( scodesFromMunicipalities.indexOf( feature.get('DCode') ) !== -1)
        {
            return adolescentBirthStyles.transparent;
        }
        const dataItem = findDataForCode(districtData, feature.get('DCode'))
        const value = dataItem ? dataItem.value : 0
        const radius = adolescentBirthRadiusMap(value);
        const color = colorMap(value);
        adolescentBirthStyles.district.setImage( getCircleStyle(radius, color) );
        return adolescentBirthStyles.district;
    });
    adolescentBirthLayers.municipality.setStyle(feature =>
    {
        const dataItem = findDataForCode(municipalityData, feature.get('SDDMM'))
        const value = dataItem ? dataItem.value : 0
        const radius = adolescentBirthRadiusMap(value);
        const color = colorMap(value);
        adolescentBirthStyles.municipality.setImage( getCircleStyle(radius, color) );
        return adolescentBirthStyles.municipality;
    });
};

export const setAdolescentBirthLayersVisible = (visible) =>
{
    Object.values(adolescentBirthLayers).forEach(layer => layer.setVisible(visible));
};

export const setAdolescentBirthLayersOpacity = opacity =>
{
    Object.values(adolescentBirthLayers).forEach(layer => layer.setOpacity( parseFloat(opacity) ));
};

export const setPopulationLayersOpacity = opacity =>
{
    Object.values(populationLayers).forEach(layer => layer.setOpacity( parseFloat(opacity) ));
};

// function to set visibility of all the layers in population group 
export const setAllPopulationLayersVisible = (visible) =>
{
    setPopulationLayersVisible(visible);
    setAdolescentBirthLayersVisible(visible);
};

// population radio group info to be used in creating ui of layer selection in the population group of sidebar
export const populationLayerGroupInfo = [
    // {
    //     id: 'population',
    //     title: 'Population',
    //     titleNepali: 'जनसंख्या',
    //     layers: [
    //        {
    //           id: 'population',
    //           field: 'population',
    //           colorMap: populationColorMap,
    //           visible: true,
    //           titleNepali: "जनसंख्या",
    //           titleEnglish: "Population",
    //           sourceInfo: 'Population',
    //           description: 'Population data for district &\nmunicipalities is not accurate and they\nare there only for the purposes of demonstration.',
    //           legendPath: populationLegendURL.dataurl,
    //        },
    //     ]
    // },
    {
        id: 'popAG',
        title: 'Population of adolescent girls',
        titleNepali: 'किशोरी जनसंख्या',
        layers: [
        {
            id: 'birth2011',
            field: 'birth2011',
            legendIsShown: false,
            visible: false,
            colorMap: adolescentBirthColorMap,
            titleNepali: 'किशोरी जनसंख्या, २०११',
            titleEnglish: "Birth to adolescent girls, 2011",
            legendPath: adolescentBirthLegendURL.dataurl,
            legendPathNepali: adolescentBirthLegendURLNepali.dataurl,
        },
        {
            id: 'birth2016',
            field: 'birth2016',
            colorMap: adolescentBirthColorMap,
            legendIsShown: false,
            visible: false,
            titleNepali: 'किशोरी जनसंख्या, २०१६',
            titleEnglish: "Birth to adolescent girls, 2016",
            legendPath: adolescentBirthLegendURL.dataurl,
            legendPathNepali: adolescentBirthLegendURLNepali.dataurl,
        },
        // {
        //    id: 'diff',
        //    field: 'diff',
        //    colorMap: birthDiffColorMap,
        //     legendIsShown: false,
        //     visible: false,
        //    titleNepali: "किशोरीको जन्ममा वृद्धि, २०११-२०१६",
        //    titleEnglish: "Change in births to adolescent girls, 2011-2016",
        //    legendPath: birthDiffLegendURL.dataurl,
        // },
        ]
    },
];